export default __webpack_public_path__ + "static/media/mash.85814f26.png";